import { useState } from "react";
import generateUniqueId from "./generateUniqueId.mjs";
function useUniqueId(id, prefix) {
  const [defaultId] = useState(() => `${prefix ? prefix + "-" : ""}${generateUniqueId()}`);
  return id ?? defaultId;
}
export { useUniqueId as default };